import React from 'react'
import './Name.css'
const Name = () => {
  return (
    <>
        <div className="NameBox">
            <h3 className='name'>Priyam Maini</h3>
        </div>
    </>
  )
}

export default Name